import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FormSummaryRow from './formSummaryRow';
import { GroupWrapper, GroupTitle } from './css';

const FormSummaryGroup = ({ data, orderData: backendObject }) => {
  const isFieldVisible = backendFieldValidation => {
    let isVisible = true;
    if (backendFieldValidation) {
      for (let i = 0; i < backendFieldValidation.length; i += 1) {
        const {
          fields: { key: fieldKey, value }
        } = backendFieldValidation[i];
        isVisible =
          isVisible &&
          (value.split('|').includes(backendObject[fieldKey]) ||
            (value.split('|').includes('undefined') &&
              typeof backendObject[fieldKey] === 'undefined'));
      }
    }
    return isVisible;
  };

  const {
    fields: { backendFields, backendKey, name, backendFieldValidation }
  } = data;
  if (!isFieldVisible(backendFieldValidation)) return null;
  return backendFields.map((backendField, index) => {
    const {
      sys: {
        contentType: {
          sys: { id }
        },
        id: sysId
      },
      fields: { backendFieldValidation: subBackendFieldValidation }
    } = backendField;
    const key = `summary-${backendKey}${index}${sysId}${name}`;

    if (!isFieldVisible(subBackendFieldValidation)) return null;
    if (id === 'formSummaryStepGroup') {
      return (
        <GroupWrapper style={{ marginBottom: '1em', paddingLeft: 0, paddingRight: 0 }}>
          <GroupTitle style={{ marginBottom: '1em' }}>
            {backendField.fields.name}
          </GroupTitle>
          <FormSummaryGroup data={backendField} orderData={backendObject} />
        </GroupWrapper>
      );
    }
    if (id === 'repeatedSummaryGroup') {
      const keyValue = backendObject[backendField.fields.key];
      const currentFieldName = backendField.fields.name;
      const subObjectList = (Array.isArray(keyValue) && keyValue) || [];
      if (!subObjectList.length) return null;
      return (
        <GroupWrapper style={{ marginBottom: '1em', paddingLeft: 0, paddingRight: 0 }}>
          {subObjectList.map((item, i) => {
            const subSecKey =
              subObjectList.length > 1
                ? `${currentFieldName} ${i + 1}`
                : currentFieldName;
            return (
              <Fragment key={subSecKey}>
                <GroupTitle style={{ marginBottom: '1em' }}>
                  {subSecKey}
                </GroupTitle>
                <FormSummaryGroup data={backendField} orderData={item} />
              </Fragment>
            );
          })}
        </GroupWrapper>
      );
    }
    const { key: fieldKey, label, value: fieldValue } = backendField.fields;
    const value = backendObject[fieldKey];
  
    return (
      <FormSummaryRow
        key={key}
        label={label}
        value={typeof value === 'boolean' ? fieldValue : value}
        isDollarRemove
      />
    );
  });
};

FormSummaryGroup.propTypes = {
  data: PropTypes.shape({
    backendKey: PropTypes.string,
    backendFields: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default FormSummaryGroup;
